export const hvProjectTrackerDataSources = [
  {
    title: 'HV Project Order Tracker',
    content: `HV Project Order Tracker's core use cases include order tracking, notifications and alerts, operational and analytical dashboards, and leadership-level reporting. The application leverages multiple underlying data sources. These include SAP data ingested via the Enterprise Data Platform (EDP), Power BI reports, system-generated calculated values, and manually maintained or adjusted data points.`,
    sourceSystem: null,
    prompts: [],
    datasourcelink: ''
  }
]
